import SalesSurveyIndex from "@/components/sales_survey/CML/SalesSurveyIndex.vue";
import SalesSurveyDetail from "@/components/sales_survey/CML/SalesSurveyDetail.vue";
import SalesSurveyEdit from "@/components/sales_survey/CML/SalesSurveyEdit.vue";
import SalesSurveyCreate from "@/components/sales_survey/CML/SalesSurveyCreate.vue";
import SalesSurveyUpload from "@/components/sales_survey/CML/SalesSurveyUpload.vue";

import BpSalesSurveyIndex from "@/components/sales_survey/BP/SalesSurveyIndex.vue";
import BpSalesSurveyDetail from "@/components/sales_survey/BP/SalesSurveyDetail.vue";
import BpSalesSurveyEdit from "@/components/sales_survey/BP/SalesSurveyEdit.vue";
import BpSalesSurveyCreate from "@/components/sales_survey/BP/SalesSurveyCreate.vue";
import BpSalesSurveyUpload from "@/components/sales_survey/BP/SalesSurveyUpload.vue";

import SalesSurveyIndex2025 from "@/components/sales_survey/2025/SalesSurveyIndex.vue";
import SalesSurveyDetail2025 from "@/components/sales_survey/2025/SalesSurveyDetail.vue";
import SalesSurveyEdit2025 from "@/components/sales_survey/2025/SalesSurveyEdit.vue";
import SalesSurveyCreate2025 from "@/components/sales_survey/2025/SalesSurveyCreate.vue";
import SalesSurveyUpload2025 from "@/components/sales_survey/2025/SalesSurveyUpload.vue";


import CMLIndex from "@/components/sales_survey/CML/Index.vue";
import CMLIndex2025 from "@/components/sales_survey/2025/Index.vue";

let SalesSurveyRoute = [
  {
    path: "cml",
    component:CMLIndex,
    children: [
      {
        path: "",
        meta: {
          title: "Sales Survey Index",
        },
        name: "CMLSalesSurveyIndex",
        component: SalesSurveyIndex,
      },

      {
        path: "detail/:id",
        meta: {
          title: "Sales Survey Detail",
        },
        name: "CMLSalesSurveyDetail",
        component: SalesSurveyDetail,
      },

      {
        path: "edit/:id",
        meta: {
          title: "Sales Survey Update",
        },
        name: "CMLSalesSurveyEdit",
        component: SalesSurveyEdit,
      },

      {
        path: "create",
        meta: {
          title: "Sales Survey Create",
        },
        name: "CMLSalesSurveyCreate",
        component: SalesSurveyCreate,
      },
      {
        path: "upload",
        meta: {
          title: "Sales Survey Upload",
        },
        name: "CMLSalesSurveyUpload",
        component: SalesSurveyUpload,
      },
    ],
  },
  {
    path: "bp",
    component:CMLIndex,
    children: [
      {
        path: "",
        meta: {
          title: "Sales Survey Index",
        },
        name: "BpSalesSurveyIndex",
        component: BpSalesSurveyIndex,
      },

      {
        path: "detail/:id",
        meta: {
          title: "Sales Survey Detail",
        },
        name: "BpSalesSurveyDetail",
        component: BpSalesSurveyDetail,
      },

      {
        path: "edit/:id",
        meta: {
          title: "Sales Survey Update",
        },
        name: "BpSalesSurveyEdit",
        component: BpSalesSurveyEdit,
      },

      {
        path: "create",
        meta: {
          title: "Sales Survey Create",
        },
        name: "BpSalesSurveyCreate",
        component: BpSalesSurveyCreate,
      },
      {
        path: "upload",
        meta: {
          title: "Sales Survey Upload",
        },
        name: "BpSalesSurveyUpload",
        component: BpSalesSurveyUpload,
      },
    ],
  },
  {
    path: "v2",
    component:CMLIndex2025,
    children: [
      {
        path: "",
        meta: {
          title: "Sales Survey Index",
        },
        name: "SalesSurveyIndex2025",
        component: SalesSurveyIndex2025,
      },

      {
        path: "detail/:id",
        meta: {
          title: "Sales Survey Detail",
        },
        name: "SalesSurveyDetail2025",
        component: SalesSurveyDetail2025,
      },

      {
        path: "edit/:id",
        meta: {
          title: "Sales Survey Update",
        },
        name: "SalesSurveyEdit2025",
        component: SalesSurveyEdit2025,
      },

      {
        path: "create",
        meta: {
          title: "Sales Survey Create",
        },
        name: "SalesSurveyCreate2025",
        component: SalesSurveyCreate2025,
      },
      
      {
        path: "upload",
        meta: {
          title: "Sales Survey Upload",
        },
        name: "SalesSurveyUpload2025",
        component: SalesSurveyUpload2025,
      },
      
    ],
  },
  {
    path: "",
    redirect: "/sales-survey/cml",
    // meta: {
    //   title: "Sales Survey Index",
    // },
    // name: "SalesSurveyIndex",
    // component: SalesSurveyIndex,
  },
  
];

export default SalesSurveyRoute;
